module.exports = __webpack_public_path__ + "img/smart3.940019b0.png";